import { AlertWindow } from '@sunwebgroup/uds-ui/alert-window'
import { Button } from '@sunwebgroup/uds-ui/button'
import { useIntl } from '@/intl'
import { useBookingDetailsActions } from '@/scopes/account/booking-details/infrastructure/dependencies/dependencies'
import { useBookingDetailsStore } from '@/scopes/account/booking-details/infrastructure/useBookingDetailsStore'
import { getIsDeleteBookingRequestLoading } from '@/scopes/account/booking-details/pages/selectors'

export function ConfirmDeletionAlertContent() {
  const { formatMessage } = useIntl()
  const { bookingDeletionRequested, bookingDeletionDialogClosed } = useBookingDetailsActions()
  const isLoading = useBookingDetailsStore(getIsDeleteBookingRequestLoading)

  return (
    <AlertWindow.Content
      text={formatMessage({ id: 'booking_details_manage_booking_delete_window_title' })}
      supportingText={formatMessage({ id: 'booking_details_manage_booking_delete_window_text' })}
      renderPrimaryActionSlot={props => (
        <Button
          {...props}
          isLoading={isLoading}
          disabled={isLoading}
          onClick={bookingDeletionRequested}
          ariaLabel={formatMessage({ id: 'booking_details_manage_booking_delete_window_delete_button_label' })}
        >
          {formatMessage({ id: 'booking_details_manage_booking_delete_window_delete_button_label' })}
        </Button>
      )}
      renderSecondaryActionSlot={props => (
        <Button
          {...props}
          disabled={isLoading}
          onClick={bookingDeletionDialogClosed}
          ariaLabel={formatMessage({ id: 'booking_details_manage_booking_delete_window_cancel_button_label' })}
        >
          {formatMessage({ id: 'booking_details_manage_booking_delete_window_cancel_button_label' })}
        </Button>
      )}
    />
  )
}
